import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import FilterListIcon from '@material-ui/icons/FilterList';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft:'10px',
    paddingRight:'10px'
    /*position: 'fixed',
    left: '50%',
    backgroundColor: 'white',
    top: '10px',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },*/
  },
  hidden: {
      display: 'none'
  },
  alertCloseIcon: {
    "& .MuiAlert-action": {
      alignItems: 'baseline'   
    },
    fontSize: 'small'
  }
}));

export default function SimpleAlerts(props) {
  const classes = useStyles();

  const [open, setOpen] = useState(true);

  let sifko, oid;

  if (props.imeObjekta) {
    const splitted = props.idObjekta.split('-');
    sifko = splitted[0];
    oid = splitted[1];
  }

  const msg = props.imeObjekta ? <div>Sloji z vključenim filtrom prikazujejo samo dostopnost za objekt <a target="_blank" href={`http://dostopnost.javniobjekti.si/prikaz?i_ko=${sifko}&i_obj=${oid}`}>{props.imeObjekta}</a>. <br/>
        S pritiskom na ikono <FilterListIcon style={{fontSize: 'small'}}></FilterListIcon> ob sloju lahko filter za dotični sloj izključite ali ponovno vključite.
        </div> : <div>Objekta ID <b>{props.idObjekta}</b> ni v bazi.</div>;

  const a = () => <FilterListIcon style={{fontSize: 'small'}}></FilterListIcon>

  return (
    <div className={`${classes.root} ${props.show && open ? '' : classes.hidden}`}>
      <Alert className={classes.alertCloseIcon} onClose={() => {setOpen(false)}} variant="outlined" severity={props.imeObjekta ? "info" : "warning"}>
        {msg}
      </Alert>
    </div>
  );
}